import { render, staticRenderFns } from "./quesViewInfo.vue?vue&type=template&id=16b52f9a"
import script from "./quesViewInfo.vue?vue&type=script&lang=js"
export * from "./quesViewInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports